export const DATA_PROTECTION_PAGE_ID = 'eu-data-protection'
export const KEYBOARD_SHORTCUTS_PAGE_ID = 'keyboard-shortcuts'
export const TERMS_OF_USE_PAGE_ID = 'terms-of-use'

export function resolveSitePagePath(pageId: string): string {
  switch (pageId) {
    case 'about':
      return '/about'
    case 'imprint':
      return '/imprint'
    case 'privacy-policy':
      return '/privacy-policy'
    case DATA_PROTECTION_PAGE_ID:
      return '/data-protection'
    case KEYBOARD_SHORTCUTS_PAGE_ID:
      return '/keyboard-shortcuts'
    case TERMS_OF_USE_PAGE_ID:
      return '/terms-of-use'
    case 'home':
      return '/home'
    default:
      return '/about'
  }
}
